import { useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelledPage() {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-background" data-testid="payment-cancelled-page">
            <Header />
            <section className="max-w-3xl mx-auto px-6 py-32 text-center">
                <XCircle size={56} strokeWidth={1} className="text-muted-foreground mx-auto mb-8" />
                <div className="overline mb-4">Payment cancelled</div>
                <h1 className="font-serif text-5xl tracking-tighter">No worries.</h1>
                <p className="mt-6 text-muted-foreground max-w-md mx-auto">
                    Your booking is held but unpaid. You can complete payment from My Bookings, or try a different service.
                </p>
                <div className="mt-10 flex flex-wrap gap-3 justify-center">
                    <Button
                        onClick={() => navigate("/my-bookings")}
                        className="bg-primary text-primary-foreground rounded-sm uppercase tracking-[0.2em] text-xs h-12 px-7"
                        data-testid="cancelled-bookings-btn"
                    >
                        My Bookings
                    </Button>
                    <Button
                        variant="outline"
                        onClick={() => navigate("/services")}
                        className="rounded-sm uppercase tracking-[0.2em] text-xs h-12 px-7 border-white/10 bg-transparent"
                        data-testid="cancelled-services-btn"
                    >
                        Browse Services
                    </Button>
                </div>
            </section>
        </div>
    );
}
